import {
    LOADING_PRISTINE,
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE,
    SET_USER_EVENTS,
    SET_USER,
    LOAD_USER_EVENTS,
    AUTH_HEADER_TOKEN,
    LOAD_USER,
    ADD_USER_EVENT,
    REMOVE_USER_EVENT,
    REMOVE_MANY_USER_EVENTS,
    ACTION_FAVORITE,
    LOAD_USER_ATTRIBUTES,
    SET_USER_ATTRIBUTES,
    UPDATE_USER,
    ADD_USER_ATTRIBUTES,
    GET_USER_FAVORITES,
    CONTACT,
    SET_CONTACT_STATE,
} from '../services/constants'
import lodash from '../services/lodash'
import helpers from '../services/helpers'
import http from '../services/axios'

const store = {
    state: {
        events: {
            state: LOADING_PRISTINE,
            data: null,
            error: null,
        },
        attributes: {
            state: LOADING_PRISTINE,
            data: null,
            error: null,
        },
        contact: {
            state: LOADING_PRISTINE,
            data: null,
            error: null,
        },
    },
    getters: {
        [GET_USER_FAVORITES](state) {
            if (state.events.data) {
                return state.events.data.filter(event => {
                    return event.action === ACTION_FAVORITE
                })
            }
            return []
        },
    },
    mutations: {
        [SET_USER_EVENTS]: (state, payload) => {
            state.events = lodash.cloneDeep(payload)
        },
        [SET_USER_ATTRIBUTES]: (state, payload) => {
            state.attributes = lodash.cloneDeep(payload)
        },
        [SET_CONTACT_STATE]: (state, payload) => {
            state.contact = lodash.cloneDeep(payload)
        },
    },
    actions: {
        [LOAD_USER_EVENTS]: (context) => {
            context.commit(SET_USER_EVENTS, {
                state: LOADING_STARTED,
                data: context.state.events.data,
                error: null,
            });
            const config = {
                headers: {
                    [AUTH_HEADER_TOKEN]: `Bearer ${context.rootState.session.data}`,
                },
                params: {
                    expand: true
                }
            }
            http.get(`users/current/events`, config).then(results => {
                results.data.forEach(event => {
                    event.entry = helpers.mapEntry(event.entry)
                    if (event.action === ACTION_FAVORITE && event.content) {
                        event.content = helpers.parseJSONOrNull(event.content)
                    }
                })
                context.commit(SET_USER_EVENTS, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: results.data,
                    error: null,
                });
            }).catch(err => {
                context.commit(SET_USER_EVENTS, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err.message,
                });
            })
        },
        [ADD_USER_EVENT]: (context, payload) => {
            context.commit(SET_USER_EVENTS, {
                state: LOADING_STARTED,
                data: context.state.events.data,
                error: null,
            });
            const config = {
                headers: {
                    [AUTH_HEADER_TOKEN]: `Bearer ${context.rootState.session.data}`
                }
            }
            http.post(`users/current/events`, payload, config).then(results => {
                context.dispatch(LOAD_USER_EVENTS)
            }).catch(err => {
                context.commit(SET_USER_EVENTS, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err.message,
                })
            })
        },
        [REMOVE_USER_EVENT]: (context, payload) => {
            context.commit(SET_USER_EVENTS, {
                state: LOADING_STARTED,
                data: null,
                error: null,
            });
            const config = {
                headers: {
                    [AUTH_HEADER_TOKEN]: `Bearer ${context.rootState.session.data}`
                }
            }
            http.delete(`users/current/events/${payload}`, config).then(results => {
                context.dispatch(LOAD_USER_EVENTS)
            }).catch(err => {
                context.commit(SET_USER_EVENTS, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err.message,
                })
            })
        },
        [REMOVE_MANY_USER_EVENTS]: (context, payload) => {
            context.commit(SET_USER_EVENTS, {
                state: LOADING_STARTED,
                data: null,
                error: null,
            });
            const config = {
                headers: {
                    [AUTH_HEADER_TOKEN]: `Bearer ${context.rootState.session.data}`
                }
            }

            http.all(payload.map(entryID => {
                return http.delete(`users/current/events/${entryID}`, config)
            })).then(results => {
                context.dispatch(LOAD_USER_EVENTS)
            }).catch(err => {
                context.commit(SET_USER_EVENTS, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err.message,
                })
            })
        },
        [LOAD_USER_ATTRIBUTES]: (context) => {
            context.commit(SET_USER_ATTRIBUTES, {
                state: LOADING_STARTED,
                data: null,
                error: null,
            });
            const config = {
                headers: {
                    [AUTH_HEADER_TOKEN]: `Bearer ${context.rootState.session.data}`,
                }
            }
            http.get(`users/current/attributes`, config).then(results => {
                // results.data.forEach(event => {
                //     event.entry = helpers.mapEntry(event.entry)
                //     if (event.action === ACTION_FAVORITE && event.content) {
                //         event.content = helpers.parseJSONOrNull(event.content)
                //     }
                // })
                context.commit(SET_USER_ATTRIBUTES, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: results.data,
                    error: null,
                });
            }).catch(err => {
                context.commit(SET_USER_ATTRIBUTES, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err.message,
                });
            })
        },
        [ADD_USER_ATTRIBUTES]: (context, payload) => {
            const config = {
                headers: {
                    [AUTH_HEADER_TOKEN]: `Bearer ${context.rootState.session.data}`
                }
            }
            return http.post(`users/current/attributes`, payload, config).then(results => {
                return context.dispatch(LOAD_USER_ATTRIBUTES)
            }).catch(err => {
                console.log('could not update user attributes')
            })
        },
        [UPDATE_USER]: (context, payload) => {
            const config = {
                headers: {
                    [AUTH_HEADER_TOKEN]: `Bearer ${context.rootState.session.data}`
                }
            }
            return http.post(`users/current`, payload, config).then(results => {
                context.dispatch(LOAD_USER)
            }).catch(err => {
                console.log('could not update user')
            })
        },
        [CONTACT]: (context, payload) => {
            context.commit(SET_CONTACT_STATE, {
                state: LOADING_STARTED,
                data: context.state.contact.data,
                error: null,
            });
            const config = {
                headers: {
                    [AUTH_HEADER_TOKEN]: `Bearer ${context.rootState.session.data}`
                }
            }
            return http.postAppAddon(`contact`, payload, config).then(results => {
                context.commit(SET_CONTACT_STATE, {
                    state: LOADING_COMPLETED_SUCCESS,
                    data: results,
                    error: null,
                });
            }).catch(err => {
                context.commit(SET_CONTACT_STATE, {
                    state: LOADING_COMPLETED_FAILURE,
                    data: null,
                    error: err.message,
                });
            })
        },
    }
}

export default store
export const user = store